// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import Classnames from "classnames";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Hooks$PrezzeeRibbon from "../../../abstracts/Hooks.bs.js";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";
import * as Accordion__Provider$PrezzeeRibbon from "./Accordion__Provider.bs.js";

function panel(currentHeight) {
  return BsCssJs$PrezzeeRibbon.merge([
              Theme__Typography$PrezzeeRibbon.Styles.body,
              BsCssJs$PrezzeeRibbon.style([
                    BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.pxFloat(currentHeight)),
                    BsCssJs$PrezzeeRibbon.transition(Theme__Animation$PrezzeeRibbon.slow, undefined, "ease", "max-height"),
                    BsCssJs$PrezzeeRibbon.overflow("hidden")
                  ])
            ]);
}

var content = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(22)),
      BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(16)),
      BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(16)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [
            BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(22)),
            BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(22))
          ])
    ]);

var Styles = {
  panel: panel,
  content: content
};

function Accordion__Panel(props) {
  var className = props.className;
  var children = props.children;
  var className$1 = className !== undefined ? className : "";
  var match = React.useContext(Accordion__Provider$PrezzeeRibbon.context);
  var state = match[0];
  var match$1 = React.useState(function () {
        return 0;
      });
  var setHeight = match$1[1];
  var container = React.useRef(null);
  var windowSize = Hooks$PrezzeeRibbon.useWindowSize(undefined, undefined);
  React.useEffect((function () {
          if (state.expanded) {
            Belt_Option.forEach(Caml_option.nullable_to_opt(container.current), (function (containerEl) {
                    Curry._1(setHeight, (function (param) {
                            return containerEl.getBoundingClientRect().height;
                          }));
                  }));
          } else {
            Curry._1(setHeight, (function (param) {
                    return 0;
                  }));
          }
        }), [
        windowSize,
        children,
        state.expanded
      ]);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: children,
                    ref: Caml_option.some(container),
                    className: Classnames([
                          content,
                          className$1
                        ])
                  }),
              className: panel(match$1[0])
            });
}

var make = Accordion__Panel;

export {
  Styles ,
  make ,
}
/* content Not a pure module */
